import {useLayoutEffect,useRef,type ReactNode} from 'react';
import {PurchaseControlsPanel} from './PurchaseControlsPanel';

// Only catalog controls stick. Draw identity and prize terms scroll in both views.
// ResizeObserver updates focus/scroll clearance when the controls change height.
export function PurchaseToolbar({modal,children,filters}:{modal:boolean;children:ReactNode;filters?:ReactNode}){
 const ref=useRef<HTMLDivElement>(null);
 useLayoutEffect(()=>{
  const element=ref.current;if(!element)return;
  const container=modal?element.closest<HTMLElement>('.next-round-purchase'):document.documentElement;
  if(!container)return;
  const update=()=>container.style.setProperty('--room-purchase-sticky-height',element.getBoundingClientRect().height+'px');
  if(!modal)container.classList.add('tombala-purchase-sticky-active');
  update();const observer=new ResizeObserver(update);observer.observe(element);
  return()=>{observer.disconnect();if(!modal)container.classList.remove('tombala-purchase-sticky-active');container.style.removeProperty('--room-purchase-sticky-height');};
 },[modal]);
 return <div ref={ref} className="room-purchase-toolbar"><PurchaseControlsPanel filters={filters}>{children}</PurchaseControlsPanel></div>;
}
